const ENV = process.env.REACT_APP_ENV;

const config = {
    backendUrl: 
      ENV === 'production' ?
        'https://api.grieversandfriends.com' :
        'https://sandbox.api.grieversandfriends.com',
  };
  
  export default config;  